module.exports = __webpack_public_path__ + "static/img/c9.98b6f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/c9.png
// module id = ppdI
// module chunks = 0